import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { clearToken, readToken, request, saveToken } from './client';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const restore = useCallback(async () => {
    setLoading(true);
    setError('');
    try { setUser(readToken() ? await request('') : null); }
    catch (failure) {
      setUser(null);
      if (failure.status !== 401) setError('No pudimos verificar tu sesión. Revisá la conexión e intentá nuevamente.');
    } finally { setLoading(false); }
  }, []);
  useEffect(() => {
    restore();
    const expire = () => { setUser(null); setError(''); };
    const sync = (event) => { if (event.key === 'project.auth.token' || event.key === null) restore(); };
    window.addEventListener('auth:expired', expire);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('auth:expired', expire);
      window.removeEventListener('storage', sync);
    };
  }, [restore]);
  useEffect(() => {
    if (!user?.expiresAt) return;
    const remaining = new Date(user.expiresAt).getTime() - Date.now();
    const timer = setTimeout(() => { clearToken(); setUser(null); }, Math.max(0, remaining));
    return () => clearTimeout(timer);
  }, [user]);
  async function login(values) {
    const result = await request('', { method: 'POST', body: JSON.stringify(values) });
    saveToken(result.token, values.recordar);
    setUser({ idUsuario: result.idUsuario, nombre: result.nombre, username: result.username, expiresAt: result.expiresAt });
    setError('');
  }
  async function logout() {
    await request('/logout', { method: 'POST' });
    clearToken();
    setUser(null);
  }
  return <AuthContext.Provider value={{ user, loading, error, restore, login, logout }}>{children}</AuthContext.Provider>;
}
